import ScalarIconLockSimple_vue_vue_type_script_setup_true_lang_default from "./ScalarIconLockSimple.vue.script.js";
//#region src/components/ScalarIconLockSimple.vue
var ScalarIconLockSimple_default = ScalarIconLockSimple_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconLockSimple_default as default };

//# sourceMappingURL=ScalarIconLockSimple.js.map